<template>
    <div class="c-rkw-selectbox">
        <div class="c-rkw-selectbox__selected" @click.prevent="toggleOpen">{{getLabel()}}</div>
        <div class="c-rkw-selectbox__options" :class="{'c-rkw-selectbox__options--open': open}" v-on="{mouseleave: closeBox}">
            <div v-for="(option, optionKey, optionIndex) in options" class="c-rkw-selectbox__option" :class="{'c-rkw-selectbox__option--active': option[1] === selected}" @click.prevent="setSelected(option)">
                {{option[0]}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                label: "Ihr Bundesland wählen",
                open: false
            }
        },
        computed: {

        },
        methods: {
            setSelected (option) {
                this.label = option[0]
                this.$emit('change', option[1])
                this.toggleOpen()
            },
            getLabel () {
                return this.label
            },
            toggleOpen () {
                this.open = !this.open
            },
            closeBox () {
                this.open = false
            }
        },
        model: {
            prop: 'selected',
            event: 'change'
        },
        props: {
            // this allows using the `value` prop for a different purpose
            options: {
                type: Object
            },
            // use `checked` as the prop which take the place of `value`
            selected: {
                type: [Object, Boolean],
                default: false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// SelectBox.vue?b1c0d58e